import { Component, Input } from "@angular/core";

@Component({
  selector: "btn-danger",
  template: `
    <button type="button" class="btn btn-flat-danger">
      {{ label }}
    </button>
  `,
  styles: [
    `
      .btn-flat-danger {
        background-color: #ff4c5114;
      }
    `,
  ],
})
export class CustomDangerButton {
  @Input() label: string = "Cancelar";
}
